// extracted by mini-css-extract-plugin
export default {"option-sub-text":"option-sub-text--w-eKx","option":"option--hYYzd"};